import { useContext } from 'react';

import AuthModal from '@/components/authForm/AuthModal';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { AuthModalContext } from '@/context/AuthModalContextProvider';
import { useAnalytics } from '@/hooks/analytics/useAnalytics';
import { User } from '@/store/user/types';

import Header from '../header/Header';
import MeetCalm from './meet';
import Redeem from './redeem';

interface GuestPassRedeemProps {
	canRedeem: boolean;
	code: string | undefined;
	error: Error | null;
	sender: string;
	trialLength: number;
	loading: boolean;
}

const GuestPass = ({ canRedeem, code, error, sender, trialLength, loading }: GuestPassRedeemProps) => {
	const { setIsModalOpen } = useContext(AuthModalContext);
	const { logEvent } = useAnalytics();
	const { authPrompt } = useAuthPrompt();
	function onAuthSuccess(user: User) {
		logEvent({
			eventName: 'Guest Pass : Redeem : Auth : Success',
			eventProps: {
				mode: user.was_created ? 'signup' : 'login',
				mode_shown: authPrompt,
			},
		});
		if (setIsModalOpen) {
			setIsModalOpen(false);
		}
	}
	return (
		<>
			<Header useContactButton />
			<Redeem
				isLoading={loading}
				canRedeem={canRedeem}
				code={code}
				error={error}
				sender={sender}
				trialLength={trialLength}
			/>
			<MeetCalm />
			<AuthModal onAuthSuccess={onAuthSuccess} />
		</>
	);
};

export default GuestPass;
